<template>
  <div @click="onClick" class="columns">
    <div class="column is-6">
      <span class="is-uppercase is-size-7">Email schreiben: </span>
      <a :href="mailLink">{{rowData.email}}</a>
    </div>
    <div class="column is-6">
      <span class="is-uppercase is-size-7">Anrufen: </span>
      <a :href="phoneLink" class="font-numbers">{{rowData.phone}}</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  data () {
    return {
      mailLink: 'mailto:' + this.rowData.email,
      phoneLink: 'tel:' + this.rowData.phone
    }
  },
  methods: {
    onClick (event) {
      console.log('my-detail-row: on-click', event.target)
    }
  },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Players/DetailRow.vue